export { default } from './CLDocTableHead';
